export { default as Img200 } from './processed/200/Snowfall-S2.jpg';
export { default as Img400 } from './processed/400/Snowfall-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Snowfall-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Snowfall-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Snowfall-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      6,
      106,
      231
    ],
    "_population": 264,
    "_hsl": [
      0.5925925925925926,
      0.9493670886075949,
      0.4647058823529412
    ]
  },
  "LightVibrant": {
    "_rgb": [
      250,
      219,
      106
    ],
    "_population": 1520,
    "_hsl": [
      0.130787037037037,
      0.9350649350649353,
      0.6980392156862745
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      5,
      23,
      110
    ],
    "_population": 2006,
    "_hsl": [
      0.6380952380952382,
      0.9130434782608696,
      0.22549019607843138
    ]
  },
  "Muted": {
    "_rgb": [
      105,
      98,
      177
    ],
    "_population": 345,
    "_hsl": [
      0.681434599156118,
      0.3361702127659574,
      0.5392156862745098
    ]
  },
  "LightMuted": {
    "_rgb": [
      195,
      151,
      193
    ],
    "_population": 238,
    "_hsl": [
      0.8409090909090908,
      0.2682926829268292,
      0.6784313725490196
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      42,
      69
    ],
    "_population": 101,
    "_hsl": [
      0.7345679012345679,
      0.2432432432432432,
      0.21764705882352942
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Snowfall-S2.js